import React from 'react'
import CheckoutOrders from '../components/CheckOut/CheckoutOrders'

export default function CheckoutPage() {
  return (
    <div>
      <CheckoutOrders />
    </div>
  )
}
